import { Redirect } from 'expo-router';
import { useAuth } from '~/auth/contexts/auth/Auth';

export default function Index() {
  const { auth, isLoadingAuth } = useAuth();

  // Don't route on `auth` until it has resolved — a transient `null` during the
  // startup session restore/refresh must not bounce a returning user to login.
  if (isLoadingAuth) {
    return null;
  }

  if (auth) {
    return <Redirect href="/(private)" />;
  }

  return <Redirect href="/(auth)" />;
}
